import { OtherExplanationsFormValues } from '@Utils/Types/FormValuesTypes';
import {
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
} from '@Utils/validation';
import { IEsgDataPlatformOverviewFormValues } from '../Containers/EsgPlatformFormProvider/types';

export const checkOverviewThValid = (
  overview: IEsgDataPlatformOverviewFormValues
): boolean => {
  const { introduction, remark } = overview;

  const isIntroSpaceThValid =
    !introduction?.descriptionTh ||
    (introduction.descriptionTh.trim() !== '' &&
      validateSpace(introduction.descriptionTh));

  const isRemarkSpaceThValid =
    !remark?.descriptionTh ||
    (remark.descriptionTh.trim() !== '' &&
      validateSpaceTextInput(remark.descriptionTh));

  return isIntroSpaceThValid && isRemarkSpaceThValid;
};

export const checkOverviewEnValid = (
  overview: IEsgDataPlatformOverviewFormValues
): boolean => {
  const { introduction, remark } = overview;

  const isIntroSpaceEnValid =
    !introduction?.descriptionEn ||
    (introduction.descriptionEn.trim() !== '' &&
      validateSpace(introduction.descriptionEn));

  const isRemarkSpaceEnValid =
    !remark?.descriptionEn ||
    (remark.descriptionEn.trim() !== '' &&
      validateSpaceTextInput(remark.descriptionEn));

  const isIntroductionEnValid =
    !introduction?.descriptionEn ||
    (introduction.descriptionEn.trim() !== '' &&
      validateEditorEn.test(introduction.descriptionEn));

  const isRemarkEnValid =
    !remark?.descriptionEn ||
    (remark.descriptionEn.trim() !== '' &&
      validateEditorEn.test(remark.descriptionEn));

  return (
    isIntroductionEnValid &&
    isRemarkEnValid &&
    isIntroSpaceEnValid &&
    isRemarkSpaceEnValid
  );
};

export const checkOtherDescriptionEnValid = (
  otherDescriptions: OtherExplanationsFormValues[]
): boolean => {
  return otherDescriptions.every(({ titleEn, descriptionEn }) => {
    const isTitleEnValid = !!titleEn?.trim() && validateEditorEn.test(titleEn);
    const isDescriptionEnValid =
      !!descriptionEn?.trim() && validateEditorEn.test(descriptionEn);

    return isTitleEnValid && isDescriptionEnValid;
  });
};

export const checkOtherDescriptionThValid = (
  otherDescriptions: OtherExplanationsFormValues[]
): boolean => {
  return otherDescriptions.every(
    (desc) => desc.descriptionTh?.trim() && desc.titleTh?.trim()
  );
};

const esgPassPercent =
  Number(process.env.REACT_APP_ESG_PASS_SCORE_PERCENT) || 85;
export const isEsgScoreComplete = (score: number | undefined): boolean =>
  (score ?? 0) >= esgPassPercent;
